import uibModalModule from 'angular-ui-bootstrap/src/modal';
import normalButtonComponentMod from '../../../common/material-components/buttons/normal-button.component';

import tpl from './maintenance.tpl.html';

class MaintenanceModalComponent {
  constructor($interval) {
    'ngInject';

    this.$interval = $interval;
    this.resolve = null;

    /**
     * Note for customer about the downtime, if available.
     * @type {?string}
     */
    this.note = null;

    this.close = null;
    this.dismiss = null;
  }

  $onInit() {
    this.note = this.resolve.note;
  }
}

const config = {
  templateUrl: tpl,
  controller: MaintenanceModalComponent,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};

const mod = angular.module('app.common.keepalive.maintenanceModal', [
  uibModalModule,
  normalButtonComponentMod
])

.component('maintenanceModal', config)

.factory('openMaintenanceModal', function ($uibModal) {
  return note => $uibModal.open({
    component: 'maintenanceModal',
    size: 'sm',
    backdrop: 'static',
    resolve: {note: () => note}
  });
});

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/common/keepalive/maintenance.modal.js